import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';
import { SettingsModel, SettingsWrapper } from '../../model/SettingsModel';
import { Config } from '../../config';

declare var $: any;

@Injectable()
export class AppSettingsService {
    private app: any;
    public layout: any;

    constructor() {
        if (window.location.host == 'xxx.xxx.xxx.xxx') { // TODO server ip
            Config.host = window.location.host;
            if (window.location.port == '') {
                Config.port = '70';
            }
        }

        this.app = {
            name: 'DCF',
            description: 'Written by COMEGU GmbH',
            year: ((new Date()).getFullYear()),
            apiUri: window.location.protocol + '//' + Config.host + ':' + Config.port + Config.path + '/api/',
            loginTokenUri: window.location.protocol + '//' + Config.host + ':' + Config.port + Config.path + '/token'
        };

        // Layout Settings
        // -----------------------------------
        this.layout = {
            isFixed: true,
            isCollapsed: false,
            isBoxed: false,
            isRTL: false,
            horizontal: false,
            isFloat: false,
            asideHover: false,
            theme: null,
            asideScrollbar: false,
            isCollapsedText: false,
            useFullLayout: false,
            hiddenFooter: false,
            offsidebarOpen: false,
            asideToggled: false,
            viewAnimation: 'ng-fadeInUp'
        };

    }

    getLayoutSetting(name: any) {
        return name ? this.layout[name] : this.layout;
    }

    setLayoutSetting(name: any, value: any) {
        if (typeof this.layout[name] !== 'undefined') {
            return this.layout[name] = value;
        }
    }

    toggleLayoutSetting(name: any) {
        return this.setLayoutSetting(name, !this.getLayoutSetting(name));
    }

    getAppSetting(name: any) {
        return name ? this.app[name] : this.app;
    }
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/shared/services/appsettings.service.ts